import { UploadController } from './file-upload.controller';
import template from './file-upload.html';

export const uploadComponent = {
  name: 'fdFileUpload',
  restrict: 'E',
  template,
  controller: UploadController,
  controllerAs: 'vm',
  bindings: {
    title: '@',
    body: '@',
    icon: '@',
    buttonIcon: '@',
    acceptFileTypes: '<',
    pattern: '<',
    required: '<',
    testId: '@',
    uploadUrl: '@',
    upload: '&',
    uploadStart: '&',
    uploadDone: '&',
    uploadFail: '&',
    uploadFinally: '&',
    onFileClick: '&',
    hideUploadSummary: '=',
    singleUpload: '<',
    disabled: '=',
    isBusy: '=',
    multipleUpload: '<', // maybe someone has a better name?
    files: '=?',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-file-upload/src/file-upload.component.js